import { useNavigate, useLocation } from 'react-router-dom';

/**
 * Hook for handling logout with smart redirects
 */
export const useLogout = (onLogout: () => void) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    // Call the original logout function
    onLogout();
    
    // Check if user is on a protected page and redirect if needed
    const protectedPaths = ['/checkout', '/profile', '/admin'];
    const isOnProtectedPage = protectedPaths.some(path => 
      location.pathname.startsWith(path)
    );
    
    if (isOnProtectedPage) {
      // Redirect to home when logging out from protected pages
      navigate('/');
    }
    // If not on protected page, stay where they are
  };

  return { handleLogout };
};